import React from "react";
import ReactLoader from "react-js-loader";

const Loader = ({ style }) => {
  const Style = style ? style : {};
  return (
    <div
      className="loader_view"
      style={{
        ...Style,
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
      }}
    >
      <ReactLoader type="bubble-loop" bgColor={"#1D7E7C"} size={100} />
    </div>
  );
};

export default Loader;
